<template>
  <div id="manageFeaturesModal">
    <div class='Fuell-Overlay'>
      <div class='Fuell-Modal'>
        <div class='Fuell-Modal--window centered'>
          <button
            class='Fuell-Modal--close-button Fuell-IconButton--close'
            @click='close'
          >
            <img
              class="Fuell-IconButton--close-img"
              :src="require('@/assets/img/icons/close.svg')"
              alt="Close"
            />
          </button>
          <h3 class='Fuell-Modal--title'>{{$t('manage_office_features_header')}}</h3>
          <div class='Fuell-Modal--content'>
            <template v-if="!isCalling">
              <div class="office-features-container">

                <toggle-switch
                  v-for="activatedFeature in activatedFeatures"
                  :key="activatedFeature.id"
                  :status.sync="activatedFeature.enabled"
                  :label="`manage_office_feature_${activatedFeature.code}`"
                  :disabled="activatedFeature.code === 'FLEXIBLE_REMUNERATION' || activatedFeature.code === 'SUBVENTION_FEATURE'"
                  :labelClass="`Label Label--text ${activatedFeature.code}`"
                  :showInfo="showInfo(activatedFeature.code)"
                  :infoText="$t(`manage_office_feature_tooltip_${activatedFeature.code}`)"
                ></toggle-switch>
                <toggle-switch
                  :status.sync="devoluiva.enabled"
                  :label="`manage_office_feature_DEVOLUIVA`"
                  :labelClass="'Label Label--text DEVOLUIVA'"
                  :disabled="customerHasDevoluiva"
                  @change="setDevoluiva"
                ></toggle-switch>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  class="Fuell-Button blue w-100"
                  @click="showConfirmSaveChangesModal"
                >
                  {{$t('ACTION_SAVE_CHANGES')}}
                </button>
              </div>
            </template>
            <template v-else>
              <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                <spinner />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <confirm-modal
      v-if="showConfirmActivateDevoluivaModalFlag"
      :id="'confirm-modal-dv'"
      :open.sync="showConfirmActivateDevoluivaModalFlag"
      :title="'office_feature_activate_devoluiva'"
      :message="''"
      :acceptText="'office_feature_activate_devoluiva'"
      :dismissText="'ACTION_CANCEL'"
      @cancel="deactivateDevoluiva"
      @accept="showConfirmActivateDevoluivaModalFlag = false"
    >
      <template v-slot:additional>
        <i18n
          class="Fuell-Text"
          tag="p"
          path="office_feature_warning"
        >
          <template v-slot:featureName>
            <span class="text-primary">{{$t('DEVOLUIVA_KEY')}}</span>
          </template>
          <template v-slot:customerName>
            <span class="text-primary">{{customer.name}}</span>
          </template>
          <template v-slot:featureWarningDanger>
            <span class="text-danger">{{$t('office_feature_warning_danger')}}</span>
          </template>
        </i18n>
        <ul class="Fuell-List">
          <li class="Fuell-List--item">{{$t('company_details_company_name')}} : <span class="text-primary">{{customer.name}}</span></li>
        </ul>
      </template>
    </confirm-modal>
    <confirm-modal
      v-if="showConfirmSaveChangesModalFlag"
      :id="'confirm-save-changes-modal'"
      :open.sync="showConfirmSaveChangesModalFlag"
      :title="'confirm_save_changes_modal'"
      :message="'confirm_save_changes_modal_message'"
      :acceptText="'ACTION_SAVE'"
      :dismissText="'ACTION_CANCEL'"
      acceptBtnClass="blue"
      @accept="activateFeatures"
      @dismiss="cancelChanges"
    />
    <confirm-modal
      v-if="showConfirmCloseChangesModalFlag"
      :id="'confirm-close-save-changes-modal'"
      :open.sync="showConfirmCloseChangesModalFlag"
      :title="'confirm_close_save_changes_modal'"
      :message="'confirm_close_save_changes_modal_message'"
      :acceptText="'ACTION_ALSO_CLOSE'"
      :dismissText="'ACTION_CANCEL'"
      acceptBtnClass="blue"
      @accept="confirmCancelChanges"
      @dismiss="cancelConfirmCancelChanges"
    />
  </div>
</template>

<script>

import { OFFICE_FEATURE_FLAGS_OPTIONS } from '../_constants/constants'
import CompanyApi from '@/modules/company/_api'
import CustomersApi from '@/modules/customers/_api'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import ToggleSwitch from '@/components/Commons/Forms/ToggleSwitch'
import Spinner from '@/components/Commons/Spinner'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'ManageOfficeFeaturesModal',
  mixins: [
    _modalHandlerMixin
  ],
  components: {
    ToggleSwitch,
    Spinner,
    ConfirmModal
  },
  props: {
    customerId: [Number, String]
  },
  data () {
    return {
      activatedFeatures: [],
      showConfirmActivateDevoluivaModalFlag: false,
      devoluiva: {
        enabled: false
      },
      customer: {},
      isCalling: true,
      showConfirmSaveChangesModalFlag: false,
      showConfirmCloseChangesModalFlag: false
    }
  },
  computed: {
    customerHasDevoluiva () {
      return this.customer.isDevoluivaActivated
    },
    officeFeatures () {
      return this.$store.getters['ConfigStore/privateConfig'].office_features || []
    },
    customerFeatures () {
      return this.customer && this.customer.offices[0] && this.customer.offices[0].activatedFeatures.length > 0 ? this.customer.offices[0].activatedFeatures : []
    },
    officeId () {
      return this.customer && this.customer.offices ? this.customer.offices[0].id : 0
    },
    featureCodeWithInfo () {
      return OFFICE_FEATURE_FLAGS_OPTIONS.filter(el => el.hasInfo).map(el => el.code)
    }
  },
  methods: {
    cancelConfirmCancelChanges () {
      this.showConfirmSaveChangesModalFlag = false
      this.showConfirmCloseChangesModalFlag = false
    },
    confirmCancelChanges () {
      this.showConfirmCloseChangesModalFlag = false
      this.close()
    },
    cancelChanges () {
      this.showConfirmSaveChangesModalFlag = false
      this.showConfirmCloseChangesModalFlag = true
    },
    showConfirmSaveChangesModal () {
      this.showConfirmSaveChangesModalFlag = true
    },
    async fetchCustomer () {
      try {
        this.isCalling = true
        const response = await CustomersApi.getCustomer(this.customerId)
        this.customer = response.data
      } catch (error) {
        this.$store.dispatch('SnackBars/addError', this.$t('customer_data_error'))
      } finally {
        this.isCalling = false
      }
    },
    close () {
      this.$emit('update:open', false)
    },
    setDevoluiva () {
      if (this.devoluiva.enabled) {
        this.showConfirmActivateDevoluivaModalFlag = true
      }
    },
    deactivateDevoluiva () {
      this.devoluiva.enabled = false
    },
    showInfo (featureCode) {
      return this.featureCodeWithInfo.includes(featureCode)
    },
    async activateDevoluiva () {
      try {
        this.isActivatingFeature = true
        await CompanyApi.putActivateDevoluiva(this.officeId)
        this.$store.dispatch('SnackBars/addSuccess', this.$t('office_feature_activation_success'))
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'office_feature_activation_error' })
      } finally {
        this.isActivatingFeature = false
        await this.fetchCustomer()
      }
    },
    async activateFeatures () {
      if (this.isActivatingFeature) return
      try {
        this.isActivatingFeature = true
        if (this.devoluiva.enabled) {
          await this.activateDevoluiva()
        }
        const featuresToActivate = this.activatedFeatures.filter(el => el.enabled).map(item => { return { feature: { id: item.id } } })
        if (featuresToActivate) {
          const features = {
            activatedFeatures: featuresToActivate
          }
          await CompanyApi.putActivateFeature(this.officeId, features)
          this.$store.dispatch('SnackBars/addSuccess', this.$t('office_feature_activation_success'))
        } else {
          this.$store.dispatch('SnackBars/addError', this.$t('office_feature_feature_not_found_error'))
        }
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'office_feature_activation_error' })
      } finally {
        await this.fetchCustomer()
        this.devoluiva.enabled = this.customerHasDevoluiva
        this.showConfirmSaveChangesModalFlag = false
        this.showConfirmCloseChangesModalFlag = false
        this.isActivatingFeature = false
        this.close()
      }
    },
    getActivatedFeatures () {
      this.officeFeatures.forEach(officeFeature => {
        if (officeFeature.code !== 'FUNNEL_FEATURE' && officeFeature.code !== 'MERCHANT_FEATURE' && officeFeature.code !== 'TRANSACTION_WARNING_FEATURE') {
          let enabled = false
          this.customerFeatures.forEach(customerFeature => {
            if (officeFeature.code === customerFeature.feature.code) {
              enabled = true
            }
          })
          this.activatedFeatures.push({ ...officeFeature, enabled: enabled })
        }
      })
    }
  },
  async created () {
    await this.fetchCustomer()
    this.devoluiva.enabled = this.customerHasDevoluiva
    this.getActivatedFeatures()
  }

}
</script>

<style lang="scss">
#manageFeaturesModal {
  .Fuell-Modal--window {
    width: 450px;
    max-width: 450px;
    padding: 24px;
    .office-features-container .toggle-switch {
      justify-content: space-between;
      margin-bottom: 16px;
      .Fuell-Toggle-switch {
        order: 1;
        margin-right: 0 !important;
      }
    }
    .Fuell-Modal--title {
      height: auto;
      line-height: initial;
    }
    .Fuell-Modal--content {
      align-items: inherit;
    }
  }
  .FLEXIBLE_REMUNERATION,
  .EXPORT_FUNNEL_FEATURE,
  .MULTI_CURRENCIES_FEATURE,
  .WATERMARK,
  .OWNER_INVITE_USER,
  .AUTO_EXCHANGE,
  .AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION,
  .MANUAL_EXPENSES_REIMBURSE,
  .SUBVENTION_FEATURE,
  .SHOW_BUDGET_FIELDS,
  .DEVOLUIVA {
    display: flex;
    &:before {
      content: "";
      display: inline-block;
      width: 24px;
      height: 24px;
      background-repeat: no-repeat;
      background-position: center;
      margin-right: 8px;
    }
  }
  .FLEXIBLE_REMUNERATION:before {
    background-image: url("~@/assets/img/icons/office-features/icon-flexible-remuneration.svg");
  }
  .SUBVENTION_FEATURE:before {
    background-image: url("~@/assets/img/icons/office-features/icon-flexible-remuneration.svg");
  }
  .EXPORT_FUNNEL_FEATURE:before {
    background-image: url("~@/assets/img/icons/office-features/icon-export.svg");
  }
  .MULTI_CURRENCIES_FEATURE:before {
    background-image: url("~@/assets/img/icons/office-features/icon-multicurrency.svg");
  }
  .WATERMARK:before {
    background-image: url("~@/assets/img/icons/office-features/icon-watermark.svg");
  }
  .OWNER_INVITE_USER:before {
    background-image: url("~@/assets/img/icons/office-features/icon-invite-users.svg");
  }
  .AUTO_EXCHANGE:before {
    background-image: url("~@/assets/img/icons/office-features/icon-auto-exchange.svg");
  }
  .AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION:before {
    background-image: url("~@/assets/img/icons/office-features/icon-avoid-restart.svg");
  }
  .DEVOLUIVA:before {
    background-image: url("~@/assets/img/icons/office-features/icon-devoluiva.svg");
  }
  .MANUAL_EXPENSES_REIMBURSE:before {
    background-image: url("~@/assets/img/icons/users/icon-transfer.svg");
  }
  .SHOW_BUDGET_FIELDS:before {
    background-image: url("~@/assets/img/icons/menu/budgets.svg");
  }
}
</style>
